/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import classNames from 'classnames';
import * as ReactDnD from 'react-dnd';

class SortableItem extends React.Component {
      static initClass() {
        this.propTypes = {
          // Identifier for the item type (for the draggable list)
          listIdentifier: PropTypes.string.isRequired,
          // Unique ID of this item when dragging
          dragItemId: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
          ]).isRequired,
          // True when this item is dragging
          dragging: PropTypes.bool,
          // True when this item is selected
          selected: PropTypes.bool,
          // Index in the list
          index: PropTypes.number.isRequired,
          // Function to render children, instead of children elements
          // signature: (classes, connectDragSource, connectDragPreview)
          render: PropTypes.func,
          // Callback for drag hover
          onDragUpdate: PropTypes.func,
          // Callback for drag cancel
          onDragCancel: PropTypes.func,
          // Callback for drag start
          onDragStart: PropTypes.func,
          // Callback for drag finish
          onDragFinish: PropTypes.func,
          // When true, the whole item is the drag source. When false, the child component is responsible
          // for calling the `connectDropTarget` prop on the appropriate drag handle
          itemIsDragSource: PropTypes.bool.isRequired
        };
  
        this.defaultProps =
          {itemIsDragSource: true};
      }

      render() {
        const classes = classNames(this.props.className, {
          'component-list-item-dragging': this.props.dragging,
          'component-list-item-selected': this.props.selected
        }
        );

        if (this.props.render != null) {
          return this.props.connectDropTarget(this.props.render(classes, this.props.connectDragSource, this.props.connectDragPreview));
        } 
          const propsForChildren =
            {connectDragSource: this.props.connectDragSource};

          const children = React.Children.map(this.props.children, function(child) {
            if (React.isValidElement(child)) {
              return React.cloneElement(child, propsForChildren);
            } 
              return child;
            
          });

          const li_props = _.omit(this.props, 'dragItemId', 'dragging', 'selected', 'index', 'render', 'onDragUpdate', 'onDragCancel', 'onDragStart', 'onDragFinish', 'itemIsDragSource', 'listIdentifier', 'isDragging', 'connectDragSource', 'connectDragPreview', 'hovered', 'connectDropTarget');
          let element = <li {...li_props} className={classes}>
                      {children}
                    </li>;
          if (this.props.itemIsDragSource) { element = this.props.connectDragSource(element); }
          element = this.props.connectDragPreview(element);
          return this.props.connectDropTarget(element);
        
      }
    }
    SortableItem.initClass();

    const dragSpec = {
      beginDrag(props, monitor, component) {
        const item = { id: props.dragItemId, index: props.index };
        if (typeof props.onDragStart === 'function') {
          props.onDragStart(item);
        }
        return item;
      },

      endDrag(props, monitor, component) {
        if (monitor.didDrop()) {
          const result = monitor.getDropResult();
          return (typeof props.onDragFinish === 'function' ? props.onDragFinish(result, {id: props.dragItemId, index: props.index}) : undefined);
        } 
          return (typeof props.onDragCancel === 'function' ? props.onDragCancel({id: props.dragItemId, index: props.index}) : undefined);
        
      }
    };

    const dragCollect = (connect, monitor) => ({
      isDragging: monitor.isDragging(),
      connectDragSource: connect.dragSource(),
      connectDragPreview: connect.dragPreview()
    });

    // DnD drop target definition
    const dropSpec = {
      drop(props, monitor, component) {
        if (!monitor.didDrop()) { return {position: props.index}; }
      },

      hover(props, monitor, component) {
        if (monitor.canDrop() && monitor.isOver({shallow: true})) {
          const item = monitor.getItem();
          if (item.id !== props.dragItemId) {
            return (typeof props.onDragUpdate === 'function' ? props.onDragUpdate(item, props.index) : undefined);
          }
        }
      }
    };

    const dropCollect = (connect, monitor) => ({
      hovered: monitor.isOver(),
      connectDropTarget: connect.dropTarget()
    });

    const dropTypes = props => props.listIdentifier;

const SortableItemDragSource = ReactDnD.DragSource(dropTypes, dragSpec, dragCollect)(SortableItem);
export const SortableItemContainer = ReactDnD.DropTarget(dropTypes, dropSpec, dropCollect)(SortableItemDragSource);